export const RadioFilterValue = {
  Include: 'include',
  Exclude: 'exclude',
  Only: 'only',
} as const;

export const RADIO_FILTER_VALUE_MAP: Record<string, boolean | null> = {
  [RadioFilterValue.Include]: null,
  [RadioFilterValue.Exclude]: false,
  [RadioFilterValue.Only]: true,
};

export const RADIO_FILTER_VALUE_REVERSE_MAP = new Map<boolean | null, string>([
  [null, RadioFilterValue.Include],
  [false, RadioFilterValue.Exclude],
  [true, RadioFilterValue.Only],
]);
